<section class="calendar-page panel">
  <header class="calendar-head">
    <div class="month-controls">
      <button mat-icon-button type="button" aria-label="Previous month" (click)="previousMonth()">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <strong>{{ monthLabel }}</strong>
      <button mat-icon-button type="button" aria-label="Next month" (click)="nextMonth()">
        <mat-icon>chevron_right</mat-icon>
      </button>
      <button mat-stroked-button type="button" (click)="currentMonth()">Today</button>
    </div>
  </header>

  <div class="legend">
    <span class="legend-item working"><i></i>Working Day</span>
    <span class="legend-item half"><i></i>Half Day</span>
    <span class="legend-item holiday"><i></i>Holiday</span>
    <span class="legend-note">Sundays are holidays by default. Saved changes override defaults.</span>
  </div>

  <div class="calendar-skeleton" *ngIf="loading">
    <span *ngFor="let item of [1,2,3,4,5,6,7,8,9,10,11,12]"></span>
  </div>

  <div class="calendar-grid" *ngIf="!loading">
    <div class="weekday" *ngFor="let day of weekdays">{{ day }}</div>
    <button type="button" class="day-cell" *ngFor="let day of days" [ngClass]="dayClass(day)" [disabled]="day.isPast || !day.inMonth" (click)="openDay(day)">
      <span class="day-number">{{ day.date | date:'d' }}</span>
      <strong>{{ day.dayType }}</strong>
      <small>{{ workHours(day.dayType) }}</small>
      <em *ngIf="day.name">{{ day.name }}</em>
      <span class="locked-note" *ngIf="day.isPast && day.inMonth">Locked</span>
      <mat-icon *ngIf="day.source === 'calendar'">edit_calendar</mat-icon>
    </button>
  </div>
</section>

<ng-template #dayDialog>
  <div class="day-dialog">
    <h2 mat-dialog-title>{{ selected?.date | date:'fullDate' }}</h2>
    <div mat-dialog-content>
      <label>
        Day Type
        <select name="dayType" [(ngModel)]="form.dayType">
          <option *ngFor="let type of dayTypes" [value]="type">{{ type }}</option>
        </select>
      </label>
      <p class="capacity">{{ workHours() }}</p>
      <label>
        Name
        <input name="name" [(ngModel)]="form.name" placeholder="Optional label" />
      </label>
      <label>
        Notes
        <textarea name="notes" [(ngModel)]="form.notes" placeholder="Optional notes"></textarea>
      </label>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button type="button" mat-dialog-close>Cancel</button>
      <button mat-flat-button color="primary" type="button" [disabled]="saving" (click)="saveDay()">
        {{ saving ? 'Saving...' : 'Save' }}
      </button>
    </div>
  </div>
</ng-template>
